module.exports = __webpack_public_path__ + "img/blue_ic_faq.74311b10.svg";